const IGNITION_ON_RPM: string = "IGNITION_ON_RPM"
const IGNITION_ON_SPEED: string = "IGNITION_ON_SPEED"
const CSV: string = "CSV"
const csv: string = "csv"
const EXCEL: string = "EXCEL"
const excel: string = "excel"
const xlsx: string = "xlsx"
const pdf: string = "pdf"
const fuelReportByVehicle: string = "fuel_report_by_vehicle"
const fuelReportByDriver: string = "fuel_report_by_driver"
const refuel: string = "refuel"
const loss:string = "loss"
const chartHeight350: number = 350
const telemetryVehiclesChoiceAll: null = null
const telemetryVehiclesChoiceActive: string = "active"
const telemetryVehiclesChoiceInactive: string = "inactive"

export {
    CSV,
    EXCEL,
    IGNITION_ON_RPM,
    IGNITION_ON_SPEED,
    csv,
    excel,
    xlsx,
    pdf,
    fuelReportByDriver,
    fuelReportByVehicle,
    loss,
    refuel,
    chartHeight350,
    telemetryVehiclesChoiceActive,
    telemetryVehiclesChoiceAll,
    telemetryVehiclesChoiceInactive,
}